import 'intersection-observer'

if (!window._babelPolyfill) {
    throw new Error('Please include babel polyfill')
}

import Vue from 'vue'
import App from './App'
import router from './router'
import './styles/main.scss';

import AsyncComputed from 'vue-async-computed'
Vue.use(AsyncComputed);

/**
 * Vue Scroll To
 * --------------------
 * https://github.com/rigor789/vue-scrollto
 */
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo);

/**
 * Vee Validate
 * --------------------
 * https://github.com/baianat/vee-validate
 */
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, {
    classes: true
});

/**
 * Vue Scroll Reveal
 * -----------------
 * https://github.com/tserkov/vue-scroll-reveal#readme
 * https://github.com/jlmakes/scrollreveal
 */
import VueScrollReveal from 'vue-scroll-reveal';
Vue.use(VueScrollReveal, {
    class: 'v-scroll-reveal',
    duration: 800,
    scale: 1,
    easing: 'cubic-bezier(0.25, 0.1, 0.2, 1)',
    distance: '30px',
    viewFactor: 0,
    mobile: true,
    reset: false
});

/**
 * FontAwesome Icons & Components
 * ------------------------------
 * https://fontawesome.com/icons?d=gallery
 * https://github.com/FortAwesome/vue-fontawesome
 */
import { FontAwesomeLayers, FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);

/**
 * WordPress Image
 * --------------------
 * Our custom component for loading images from wordpress
 * includes lazy loading below the fold
 */
import WpImage from './modules/includes/WpImage'
Vue.component('wp-image', WpImage);

/**
 * Custom Directives
 * -----------------
 */
import msGrid from './directives/msGrid'
Vue.directive('ms-grid', msGrid);

import { ObserveVisibility } from 'vue-observe-visibility'
Vue.directive('observe-visibility', ObserveVisibility);

/**
 * Globally register Vue components exposed to the window form plugins
 */
import _each from 'lodash/each';
_each(window.vueComponents || {}, (vueComponent, key) => {
    Vue.component(key, vueComponent);
});

// Animations
import FadeAnimation from './modules/includes/FadeAnimation'
Vue.use('fade-animation', FadeAnimation);

// Vue Instance
Vue.config.productionTip = false;

new Vue({
    el: '#app',
    router,
    components: { App },
    render: h => h(App)
});